<template>
<CContainer>
    <CRow>
        <CCol col="12" md="10" class="mx-auto">
            <CRow style="overflow-y: scroll;max-height: 400px;" ref="commentsContainer">
                <CCol col="12" class="bg-white text-dark p-0 shadow-sm mb-3" v-for="(comment, index) in conversation.comments" :key="index">
                    <CCard
                        class="border-0 p-0"
                    >
                        <CCardHeader
                            color="gray-200"
                            class="text-dark"
                            style="border-radius:0;"
                        >
                            <div style="max-width:50px;border-radius:50%;border:1px solid #ddd;padding:5px;" class="d-inline-block bg-affili-cerise">
                                <img class="w-100" v-if="comment.created_by && comment.created_by.avatar" :src="comment.created_by.avatar" />
                                <img class="w-100" v-else src="//statics.affili.ir/storage/assets/logo/affili-signet-white.png" />
                            </div>
                            <div style="vertical-align:middle;" class="d-inline-block mfs-2">
                                <span class="font-weight-bold">{{ comment.created_by ? comment.created_by.full_name : '--' }}</span>
                                <span class="d-block font-xs" dir="rtl">{{ $moment(comment.created_at).format('LLLL') }}</span>
                            </div>
                        </CCardHeader>
                        <CCardBody
                            v-html="comment.content.replace ? comment.content.replace(/(?:\r\n|\r|\n)/g, '<br />') : comment.content"
                            class="pb-0"
                        />
                    </CCard>
                </CCol>
            </CRow>
        </CCol>
    </CRow>
    <CRow class="mt-3 mt-md-5">
        <CCol col="12" md="10" class="mx-auto p-0">
            <CCard class="shadow-sm">
                <CCardBody>
                    <ValidationObserver ref="form" v-slot="{ invalid }" class="col" tag="div">
                        <CRow>
                            <CCustomTextarea
                                col="12"
                                v-model="comment.content"
                                :name="$t('conversation.content')"
                                :placeholder="$t('conversation.content')"
                                label=" "
                                rules="required"
                                vid="content"
                                class="reply-content"
                                rows="5"
                            />
                        </CRow>

                        <CButton :disabled="invalid" class="float-right" color="affili-eggplant" @click="sendAnswer">
                            {{ $t('conversation.send_answer') }}
                        </CButton>
                    </ValidationObserver>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</CContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'Details',

    props: {
        conversationId: {required: true}
    },

    data() {
        return {
            comment: {
                content: '',
                created_by: {
                    id: this.$policy('conversation', 'read_any') ? '-' : this.$currentUser().id,
                    full_name: this.$policy('conversation', 'read_any') ? '-' : this.$currentUser().first_name + ' ' + this.$currentUser().last_name,
                    avatar: this.$policy('conversation', 'read_any') ? null : this.$currentUser().avatar
                }
            }
        }
    },

    computed: {
        ...mapGetters('conversation', [
            'conversationById'
        ]),
        conversation() {
            return this.conversationById(this.conversationId)
        }
    },

    methods: {
        ...mapActions('conversation', {
            addComment: 'addComment',
        }),
        sendAnswer() {
            this.addComment({
                conversation_id: this.conversationId,
                ...this.comment
            }).then(() => {
                this.scrollToBottom()

                this.$refs.form.reset()
                this.comment.content = ''
            })

        },
        scrollToBottom() {
            const container = this.$refs.commentsContainer
            container.scrollTop = container.scrollHeight
        }
    },

    mounted() {
        this.scrollToBottom()
    },
}
</script>

<style lang="scss" scoped>
    .reply-content::v-deep textarea {
        resize: none;
        padding-top: 15px;
        border-width: 1.5px;
    }
</style>